export function VideoTypeIcon({
    className,
}: {
    className?: string;
}) {
    return (
        <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2634_19962)">
                <path d="M8.00016 14.6666C11.6821 14.6666 14.6668 11.6818 14.6668 7.99992C14.6668 4.31802 11.6821 1.33325 8.00016 1.33325C4.31826 1.33325 1.3335 4.31802 1.3335 7.99992C1.3335 11.6818 4.31826 14.6666 8.00016 14.6666Z" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.3335 5.97681C6.3335 5.65862 6.3335 5.49952 6.39999 5.4107C6.45794 5.3333 6.54664 5.28488 6.64308 5.27799C6.75375 5.27008 6.88758 5.35611 7.15523 5.52818L10.3023 7.55129C10.5346 7.7006 10.6507 7.77525 10.6908 7.87018C10.7258 7.95312 10.7258 8.04672 10.6908 8.12966C10.6507 8.22458 10.5346 8.29924 10.3023 8.44855L7.15523 10.4717C6.88758 10.6437 6.75375 10.7298 6.64308 10.7218C6.54664 10.715 6.45794 10.6665 6.39999 10.5891C6.3335 10.5003 6.3335 10.3412 6.3335 10.023V5.97681Z" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_2634_19962">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}

VideoTypeIcon.displayName = 'VideoTypeIcon';
